import React from 'react';
import propert1 from "../../components/asstes/ongoinging1.jpg";
import property2 from "../../components/asstes/ongoing2.jpg";
import property3 from "../../components/asstes/ongoing3.jpg";
import propert4 from "../../components/asstes/ongoing4.jpg";
import property5 from "../../components/asstes/ongoing5.jpg";

const FindYourPerfectHome = () => {
    const properties = [propert1, property2, property3, propert4, property5];
const phoneNumber = "919934822681"; 
  const message = "Hello, I want to connect with you."; 

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); // New tab में खुलेगा
  };
    return (
        <div style={{
            padding: "40px 20px",
            backgroundColor: "#f9f9f9",
            textAlign: "center",
        }}>
            <h2 style={{
                fontSize: "3rem",
                color: "rgba(35, 120, 97, 1)",
                fontFamily: "'Work Sans', sans-serif",
                fontWeight: "700",
                marginBottom: "20px",
                textTransform: "uppercase",
            }}>
                Ongoing Projects
            </h2>

            {/* Grid Container */}
            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", /* Responsive Grid */
                gap: "20px",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
                maxWidth: "1200px",
                marginLeft: "auto",
                marginRight: "auto",
            }}>
                {properties.map((property, index) => (
                    <div key={index} style={{
                        padding: "20px",
                        backgroundColor: "white",
                        borderRadius: "12px",
                        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.15)",
                        textAlign: "center",
                        transition: "transform 0.3s ease-in-out",
                        cursor: "pointer",
                    }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                    >
                        <div style={{ position: "relative", overflow: "hidden", borderRadius: "10px" }}>
                            <img
                                src={property}
                                alt="Property"
                                style={{
                                    width: "100%",
                                    height: "280px",
                                    borderRadius: "10px",
                                    objectFit: "cover",
                                    transition: "transform 0.3s ease-in-out",
                                }}
                            />
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "10px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    backgroundColor: index % 2 === 0 ? "rgba(34, 139, 34, 0.8)" : "rgba(246, 188, 152, 0.9)", /* Light green for sale, Light orange for rent */
                                    color: "#fff",
                                    padding: "8px 15px",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    borderRadius: "5px",
                                    backdropFilter: "blur(3px)",
                                    letterSpacing: "0.5px",
                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                }}
                                onClick={handleClick} 
                            >
                                {index % 2 === 0 ? "For Sale" : "For Rent"}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FindYourPerfectHome;
